import { createContext, useContext } from 'react';

import { Cluster } from '@cast/types';

import { AssignCredentialsDialogSlide } from './types';
import { FeatureName, FeatureSelection, ProductFeatures } from '../../../types';

export const AssignCredentialsDialogV2Context = createContext<{
  cluster: Cluster;
  dismiss: () => void;
  setActiveSlide: (slide: AssignCredentialsDialogSlide) => void;
  featureSelection: FeatureSelection;
  featureEnablementStatus: Partial<FeatureSelection>;
  updateFeature: (product: FeatureName, checked: boolean) => void;
  alreadyInstalledFeatures: ProductFeatures;
  promotedFeature: FeatureName | undefined;
  isPreTrial: boolean;
}>(undefined as never);

export const useAssignCredentialsDialogV2Context = () =>
  useContext(AssignCredentialsDialogV2Context);
